import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=65c25728&scoped=true&lang=pug&"
import script from "./RadioList.vue?vue&type=script&lang=js&"
export * from "./RadioList.vue?vue&type=script&lang=js&"
import style0 from "./RadioList.vue?vue&type=style&index=0&id=65c25728&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c25728",
  null
  
)

export default component.exports